<template>
  <div>
    <card title="Affiliates Accounts" :subtitle="''">
      <div>
        <Affiliate-Accounts-Table/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Affiliate-Accounts-Card'
}
</script>

<style>

</style>